import { LlmModelName } from 'notable-common';
import { z } from 'zod';
export const FlowHumanTaskToolDocumentPacketGeneratorConfigSchema = z.object({
    // This is the Companion Documents field from the legacy block
    relevantDocuments: z.string().optional(),
    // This is the Clinical Documents Packet field from the legacy block
    preGeneratedPacket: z.string().optional(),
});
export const FlowHumanTaskToolClinicalQuestionAssistantConfigSchema = z.object({
    dataContext: z.string().optional(),
    preamble: z.string().optional(),
    outputRequirements: z.string().optional(),
    additionalInstructions: z.string().optional(),
    modelName: z.enum(LlmModelName).optional(),
});
export var FlowHumanTaskToolSidekickAutofillMode;
(function (FlowHumanTaskToolSidekickAutofillMode) {
    FlowHumanTaskToolSidekickAutofillMode["Standard"] = "Standard";
    FlowHumanTaskToolSidekickAutofillMode["AiBased"] = "AiBased";
})(FlowHumanTaskToolSidekickAutofillMode || (FlowHumanTaskToolSidekickAutofillMode = {}));
export const FlowHumanTaskToolAutofillConfigSchema = z.object({
    dataContext: z.string().optional(),
    mode: z.enum(FlowHumanTaskToolSidekickAutofillMode).optional(),
});
export var FlowHumanTaskTool;
(function (FlowHumanTaskTool) {
    FlowHumanTaskTool["DocumentPacketGenerator"] = "DocumentPacketGenerator";
    FlowHumanTaskTool["ClinicalQuestionAssistant"] = "ClinicalQuestionAssistant";
    FlowHumanTaskTool["Autofill"] = "Autofill";
})(FlowHumanTaskTool || (FlowHumanTaskTool = {}));
export const FLOW_DEFAULT_ENABLED_HUMAN_TASK_TOOLS = [];
export const FlowHumanTaskToolsSchema = z
    .object({
    enabledTools: z
        .array(z.enum(FlowHumanTaskTool))
        .default(FLOW_DEFAULT_ENABLED_HUMAN_TASK_TOOLS)
        .optional(),
    config: z
        .object({
        clinicalQuestionAssistant: FlowHumanTaskToolClinicalQuestionAssistantConfigSchema.optional(),
        documentPacketGenerator: FlowHumanTaskToolDocumentPacketGeneratorConfigSchema.optional(),
        autofill: FlowHumanTaskToolAutofillConfigSchema.optional(),
    })
        .optional(),
})
    .superRefine((data, context) => {
    if (data.enabledTools?.includes(FlowHumanTaskTool.DocumentPacketGenerator)) {
        if (!data.config?.documentPacketGenerator?.relevantDocuments) {
            context.addIssue({
                code: 'custom',
                message: 'Relevant Documents are required',
                path: ['config', 'documentPacketGenerator', 'relevantDocuments'],
            });
        }
    }
});
//# sourceMappingURL=toolsConfig.js.map